import { useQuery } from '@tanstack/react-query';
import api from 'constants/api';
import Api from 'util/Api';

export interface StoreCredentials {
  storeID: number;
  username: string;
}

export interface Store {
  id: number;
  uuid: string;
  name: string;
  active: boolean;
  deleted: boolean;
  ownerType: number;
  ownerId: number;
  customerId: number;
  credentials: StoreCredentials;
  phone: string;
  contactName: string;
  email: string;
  address: string | null;
  storeCode: string;
  detail: string;
  lat: number | null;
  lng: number | null;
  notifierType: string;
  notifierTypeValue: string | null;
}

export interface StorePageSort {
  sorted: boolean;
  unsorted: boolean;
  empty: boolean;
}

export interface StorePageable {
  sort: StorePageSort;
  pageNumber: number;
  pageSize: number;
  offset: number;
  paged: boolean;
  unpaged: boolean;
}

export interface StorePage {
  content: Store[];
  pageable: StorePageable;
  sort: StorePageSort;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  size: number;
  totalElements: number;
  totalPages: number;
  empty: boolean;
}

// ponytail: size alto para traer todas las tiendas de una y filtrar en el cliente,
// igual que useMarketplaces. Si algún marketplace supera las 10000, pasar a búsqueda server-side.
const getStoresByMarketplace = async (
  marketplaceId: number,
  page = 0,
  size = 10000,
  search = '',
): Promise<Store[]> => {
  const searchParams = new URLSearchParams({
    page: String(page),
    size: String(size),
    search,
  });
  const { data } = await Api.apiAxios.get(
    `${api.stores.getByMarketplace}/${marketplaceId}?${searchParams.toString()}`,
  );
  return data.data.content ?? [];
};

export const useStoresByMarketplace = (
  marketplaceId: number | undefined,
  page = 0,
  size = 10000,
  search = '',
) => {
  return useQuery({
    queryKey: ['stores', marketplaceId, page, size, search],
    queryFn: () => getStoresByMarketplace(marketplaceId!, page, size, search),
    retry: 1,
    placeholderData: [],
    enabled: !!marketplaceId,
  });
};
